export default __webpack_public_path__ + "static/Tungsten-Bold-b9a8cc8433a94cc312e98decd2fb90db.woff2";